import React from "react";
import { Helmet } from "react-helmet-async";

export default function Privacy() {
  return (
    <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
      <Helmet>
        <title>Informativa sulla Privacy – ASD Rubiana Calcio</title>
        <meta name="description" content="Informativa sulla privacy e trattamento dei dati personali dell'ASD Rubiana Calcio ai sensi del GDPR." />
      </Helmet>

      <div className="text-overline text-yellow-400 mb-4">// Privacy</div>
      <h1 className="font-display font-black text-4xl uppercase tracking-tight mb-8">Informativa sulla Privacy</h1>

      <div className="prose prose-invert prose-zinc max-w-none text-zinc-300 leading-relaxed space-y-8">

        <section>
          <h2 className="font-display font-bold text-xl text-zinc-100 mb-3">1. Titolare del trattamento</h2>
          <p>ASD Rubiana Calcio, con sede in B.ta Ratta 15, 10040 Rubiana (TO), email: rubianacalcio2025@gmail.com</p>
        </section>

        <section>
          <h2 className="font-display font-bold text-xl text-zinc-100 mb-3">2. Dati raccolti</h2>
          <p>Il sito raccoglie i seguenti dati personali:</p>
          <ul className="list-disc pl-6 space-y-1 mt-2">
            <li>Nome e cognome</li>
            <li>Indirizzo email</li>
            <li>Numero di telefono (solo per richieste di contatto)</li>
            <li>Dati di navigazione (tramite Google Analytics)</li>
          </ul>
        </section>

        <section>
          <h2 className="font-display font-bold text-xl text-zinc-100 mb-3">3. Finalità del trattamento</h2>
          <p>I dati vengono trattati per le seguenti finalità:</p>
          <ul className="list-disc pl-6 space-y-1 mt-2">
            <li>Gestione delle iscrizioni alla newsletter</li>
            <li>Risposta alle richieste di contatto</li>
            <li>Gestione delle iscrizioni ai corsi e alle attività sportive</li>
            <li>Analisi statistica anonima del traffico sul sito (Google Analytics)</li>
            <li>Gestione della classifica del minigioco mensile</li>
          </ul>
        </section>

        <section>
          <h2 className="font-display font-bold text-xl text-zinc-100 mb-3">4. Base giuridica</h2>
          <p>Il trattamento dei dati si basa sul consenso esplicito dell'interessato (art. 6 lett. a GDPR) e sull'esecuzione di un contratto o misure precontrattuali (art. 6 lett. b GDPR).</p>
        </section>

        <section>
          <h2 className="font-display font-bold text-xl text-zinc-100 mb-3">5. Conservazione dei dati</h2>
          <p>I dati vengono conservati per il tempo strettamente necessario alle finalità per cui sono stati raccolti:</p>
          <ul className="list-disc pl-6 space-y-1 mt-2">
            <li>Dati newsletter: fino alla cancellazione dell'iscrizione</li>
            <li>Dati di contatto: 12 mesi dalla ricezione</li>
            <li>Dati di registrazione al sito: fino alla cancellazione dell'account</li>
            <li>Dati classifica gioco: fino al reset mensile</li>
          </ul>
        </section>

        <section>
          <h2 className="font-display font-bold text-xl text-zinc-100 mb-3">6. Diritti dell'interessato</h2>
          <p>Ai sensi degli artt. 15-22 GDPR, hai il diritto di:</p>
          <ul className="list-disc pl-6 space-y-1 mt-2">
            <li>Accedere ai tuoi dati personali</li>
            <li>Richiedere la rettifica o la cancellazione</li>
            <li>Opporti al trattamento</li>
            <li>Richiedere la portabilità dei dati</li>
            <li>Revocare il consenso in qualsiasi momento</li>
          </ul>
          <p className="mt-3">Per esercitare questi diritti scrivi a: <a href="mailto:rubianacalcio2025@gmail.com" className="text-yellow-400 hover:underline">rubianacalcio2025@gmail.com</a></p>
        </section>

        <section>
          <h2 className="font-display font-bold text-xl text-zinc-100 mb-3">7. Cookie e Google Analytics</h2>
          <p>Il sito utilizza Google Analytics per l'analisi statistica del traffico in forma anonima. I dati raccolti non consentono l'identificazione personale degli utenti. Per maggiori informazioni consulta la <a href="https://policies.google.com/privacy" target="_blank" rel="noopener noreferrer" className="text-yellow-400 hover:underline">privacy policy di Google</a>.</p>
        </section>

        <section>
          <h2 className="font-display font-bold text-xl text-zinc-100 mb-3">8. Modifiche</h2>
          <p>L'ASD Rubiana Calcio si riserva il diritto di modificare questa informativa in qualsiasi momento. Le modifiche saranno pubblicate su questa pagina.</p>
          <p className="mt-2 text-zinc-500 text-sm">Ultimo aggiornamento: luglio 2026</p>
        </section>

      </div>
    </div>
  );
}